import { Group } from '@visx/group'
import { Circle, Line } from '@visx/shape'

import { DOT_RADIUS } from './constants'

type Props = {
  x: number
}

const ICON_PADDING = 4
const ICON_SIZE = DOT_RADIUS * 2 - 2 * ICON_PADDING

export const AddDraftCircle = ({ x }: Props) => (
  <Group top={DOT_RADIUS / 2} left={x} className="pointer-events-none">
    <Circle
      cx={0}
      cy={0}
      r={DOT_RADIUS}
      className="fill-draft-700 stroke-draft-800 stroke-[.3px]"
    />
    <Line
      className="stroke-amaze-inkBright stroke-2"
      from={{ x: -ICON_SIZE / 2, y: 0 }}
      to={{ x: ICON_SIZE / 2, y: 0 }}
    />
    <Line
      className="stroke-amaze-inkBright stroke-2"
      from={{ x: 0, y: -ICON_SIZE / 2 }}
      to={{ x: 0, y: ICON_SIZE / 2 }}
    />
  </Group>
)
